module.exports = __webpack_public_path__ + "media/images/arena/arena-primary-afffc8818918e9f37a96cbf94fc58b50.png";